export default __webpack_public_path__ + "static/milesight-79c4caab6e41c15d4c408f8b6881b0a5.png";